// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"6e110f17","304":"b1ad9485","787":"a9f8a765"}[chunkId] + ".chunk.js";
};